import { render } from "./FrameCanvas.vue?vue&type=template&id=8d52c2f0&scoped=true&ts=true"
import script from "./FrameCanvas.vue?vue&type=script&lang=ts"
export * from "./FrameCanvas.vue?vue&type=script&lang=ts"

import "./FrameCanvas.vue?vue&type=style&index=0&id=8d52c2f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8d52c2f0"]])

export default __exports__